import { render, staticRenderFns } from "./EditRate.vue?vue&type=template&id=67123778&scoped=true&"
import script from "./EditRate.vue?vue&type=script&lang=js&"
export * from "./EditRate.vue?vue&type=script&lang=js&"
import style0 from "./EditRate.vue?vue&type=style&index=0&id=67123778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67123778",
  null
  
)

component.options.__file = "EditRate.vue"
export default component.exports